import { render, staticRenderFns } from "./UserInformationForm.vue?vue&type=template&id=0ef463cb&scoped=true"
import script from "./UserInformationForm.vue?vue&type=script&lang=js"
export * from "./UserInformationForm.vue?vue&type=script&lang=js"
import style0 from "./UserInformationForm.vue?vue&type=style&index=0&id=0ef463cb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef463cb",
  null
  
)

export default component.exports